// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MehOutlinedSvg from "@ant-design/icons-svg/es/asn/MehOutlined";
import AntdIcon from '../components/AntdIcon';

var MehOutlined = function MehOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MehOutlinedSvg
  }));
};

MehOutlined.displayName = 'MehOutlined';
export default React.forwardRef(MehOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MehOutlined.js
// module id = 1469
// module chunks = 0